import { useQuery } from "@tanstack/react-query";
import { http } from "@/lib/api";

export function useOptions() {
  const { data } = useQuery({
    queryKey: ["options"],
    queryFn: async () => (await http.get("/options")).data,
    staleTime: 5 * 60_000,
  });
  return data || {
    advertisers: [], products: [], buyers: [], managers: [], responsibles: [], users: [],
    geos: [], verticals: [], sources: [], payment_models: [], currencies: [],
    categories: [], withdraw_methods: [], payment_methods: [],
  };
}
